package com.milta.core.localization.translations.nl

import com.milta.core.localization.RouteCreationStrings

internal val RouteCreation = RouteCreationStrings(
    newRouteTitle = "Nieuwe ronde",
    stepDeliveries = "Leveringen",
    stepDrivers = "Chauffeurs",
    stepDistribution = "Verdeling",
    deliveriesSummary = "%1 leveringen · %2 pakketten",
    deliveriesSummaryOne = "1 levering · %1 pakketten",
    toFixCount = "%1 te corrigeren",
    allAddressesCorrect = "Alle adressen zijn correct",
    filterAll = "Alle %1",
    filterToFix = "Te corrigeren %1",
    fixAddressesToContinue = "Corrigeer %1 adressen om verder te gaan",
    fixOneAddressToContinue = "Corrigeer 1 adres om verder te gaan",
    continueWithDeliveries = "Doorgaan · %1 leveringen",
    continueWithOneDelivery = "Doorgaan · 1 levering",
    chooseAtLeastOneDriver = "Kies minstens één chauffeur",
    reasonMissingHouseNumber = "Huisnummer ontbreekt",
    reasonNotFound = "Adres niet gevonden",
    reasonUnverified = "Controle niet mogelijk, probeer opnieuw",
    missingHouseNumberExample = "Het huisnummer ontbreekt. Voorbeeld: %1",
    notFoundHelp = "Adres niet gevonden. Controleer de straat, het huisnummer en de postcode.",
    unverifiedHelp = "Het adres kon op dit moment niet worden gecontroleerd. Probeer het zo meteen opnieuw.",
    addToExistingHint = "Ze worden toegevoegd aan de %1 leveringen die al in de lijst staan.",
    importFileAction = "Bestand importeren",
    importFileHint = "Excel (.xlsx, .xls), CSV of PDF",
    manualEntryAction = "Handmatige invoer",
    manualEntryHint = "Naam, adres, telefoon, uiterste tijd",
    addDeliveryTitle = "Levering toevoegen",
    deleteDelivery = "Levering verwijderen",
    addedFileAnalysing = "Analyse van %1 bezig…",
    addedFileFailed = "De import van %1 is mislukt. Er is geen levering toegevoegd.",
    errorAddressesToFix = "Sommige adressen zijn niet gevalideerd: corrigeer ze in de lijst \"Te corrigeren\".",
    errorAddressesCheckRetry = "De controle van de adressen is niet gelukt. Probeer het zo meteen opnieuw.",
    errorBatchAlreadyDispatched = "Deze verdeling is al naar de chauffeurs verzonden.",
    editDeliveryTitle = "Levering wijzigen",
    zoneLabel = "Zone %1",
    workloadBalanced = "Werktijden evenwichtig verdeeld over de chauffeurs",
    workloadGap = "Verschil in werktijd tussen de chauffeurs: %1",
    importAddedFromScan = "%1 leveringen toegevoegd uit de scan",
    importAddedOneFromScan = "1 levering toegevoegd uit de scan",
    importAddedFromPdf = "%1 leveringen toegevoegd uit de pdf",
    importAddedOneFromPdf = "1 levering toegevoegd uit de pdf",
    importAddedFromSpreadsheet = "%1 leveringen toegevoegd uit het Excel-bestand",
    importAddedOneFromSpreadsheet = "1 levering toegevoegd uit het Excel-bestand",
    importAddedToFixSuffix = ", waarvan %1 te corrigeren",
    deliverySearchOpenAction = "Een levering zoeken",
    deliverySearchCount = "%1 van %2",
    deliverySearchCountToFix = "%1 van %2 te corrigeren",
    deliverySearchEmptyTitle = "Geen levering gevonden",
    deliverySearchEmptyToFixHint = "Geen te corrigeren levering gevonden. Probeer het onder ‘Alle’.",
)
